import React, { createContext, useContext, useEffect, useState } from "react";

type UserInfo = { name?: string; email?: string } | null;

interface AuthContextValue {
  user: UserInfo;
  isAuthenticated: boolean;
  login: (email: string, password: string) => boolean;
  register: (name: string, email: string, password: string) => boolean;
  logout: () => void;
  apiKey: string;
  setApiKey: (key: string) => void;
}

const DEMO_API_KEY = "AIzaSyBCKHOrg2vbPmHPLJxGb_Fp-eMDd54mzZU";

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<UserInfo>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [apiKey, setApiKeyState] = useState<string>(() => {
    try {
      return (
        localStorage.getItem("apiKey") ||
        (import.meta.env.VITE_GEMINI_API_KEY as string) ||
        DEMO_API_KEY
      );
    } catch {
      return (import.meta.env.VITE_GEMINI_API_KEY as string) || DEMO_API_KEY;
    }
  });

  useEffect(() => {
    try {
      if (apiKey) localStorage.setItem("apiKey", apiKey);
    } catch {
      // ignore storage errors
    }
  }, [apiKey]);

  const login = (email: string, password: string) => {
    if (email === "demo@aiworkspace.com" && password === "demo123") {
      setIsAuthenticated(true);
      setUser({ email, name: "Demo User" });
      return true;
    }
    return false;
  };

  const register = (name: string, email: string, _password: string) => {
    setUser({ name, email });
    setIsAuthenticated(true);
    return true;
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    try {
      localStorage.removeItem("apiKey");
    } catch {}
    setApiKeyState((import.meta.env.VITE_GEMINI_API_KEY as string) || DEMO_API_KEY);
  };

  const setApiKey = (key: string) => {
    setApiKeyState(key || ((import.meta.env.VITE_GEMINI_API_KEY as string) || DEMO_API_KEY));
  };

  return (
    <AuthContext.Provider
      value={{ user, isAuthenticated, login, register, logout, apiKey, setApiKey }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};